// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__select_option {
  transition: flex 1s;
  width: 148px;
  cursor: pointer;
  background: #262626;
  padding: 10px;
  border-radius: 25px;
  align-items: center;
}
.__select_option:hover {
  background: #000000;
}
.__select_option .__gender_name {
  color: rgba(255, 255, 255, 0.3137254902);
  font-size: 17px;
}
.__select_option .__done_icon {
  display: none;
}

.__explicit_active {
  background: #000000;
  column-gap: 16px;
}
.__explicit_active .__explicit_name {
  color: #ffffff;
  font-size: 17px;
}
.__explicit_active .__done_icon {
  display: block;
  background: #FFEE20;
  border-radius: 50%;
  color: #000000;
  font-size: 11px;
  padding: 2px;
}

.select_explicit {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/AddPopup/index.scss"],"names":[],"mappings":"AAAK;EACI,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACT;AACS;EACI,mBAAA;AACb;AAES;EACI,wCAAA;EACA,eAAA;AAAb;AAGS;EACI,aAAA;AADb;;AAIA;EACI,mBAAA;EACA,gBAAA;AADJ;AAGQ;EACG,cAAA;EACA,eAAA;AADX;AAIQ;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAFZ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAFJ","sourcesContent":["     .__select_option {\n         transition: flex 1s;\n         width: 148px;\n         cursor: pointer;\n         background: #262626;\n         padding: 10px;\n         border-radius: 25px;\n         align-items: center;\n\n         &:hover {\n             background: #000000;\n         }\n\n         .__gender_name {\n             color: #ffffff50;\n             font-size: 17px;\n         }\n\n         .__done_icon {\n             display: none;\n         }\n     }\n.__explicit_active {\n    background: #000000;\n    column-gap: 16px;\n        \n        .__explicit_name {\n           color: #ffffff;\n           font-size: 17px;\n        }\n        \n        .__done_icon {\n            display: block;\n            background: #FFEE20;\n            border-radius: 50%;\n            color: #000000;\n            font-size: 11px;\n            padding: 2px;\n                    }\n                }\n.select_explicit{\n    display: flex;\n    flex-direction: row;\n    column-gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
